// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_gfJ","cls2":"search_work_card_redesign-cls2_iPO search_work_card_redesign-cls1_gfJ"};